import { render, staticRenderFns } from "./LibraryText.vue?vue&type=template&id=238a443f&"
import script from "./LibraryText.vue?vue&type=script&lang=js&"
export * from "./LibraryText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports